export class LoginError extends Error {
  constructor() {
    super("Username or password incorrect. Please try again.");
  }
}
